import React, { useState } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { LoadingButton } from "@mui/lab";

const PrintBtn = ({ loading, data, columns, onExport, text = "Download all Data in Excel" }) => {
  const [internalLoading, setInternalLoading] = useState(false);

  const exportToExcel = async () => {
    let rowsToExport = data;
    if (onExport) {
      setInternalLoading(true);
      try {
        rowsToExport = await onExport();
      } catch (err) {
        console.error("Export error:", err);
      } finally {
        setInternalLoading(false);
      }
    }

    if (!rowsToExport || rowsToExport.length === 0) {
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    // Headers setup
    worksheet.columns = columns.map((col) => ({
      header: col.headerName || col.field,
      key: col.field,
    }));

    // Data rows processing (truncate text over 32k chars)
    rowsToExport.forEach((row) => {
      const newRow = {};
      columns.forEach((col) => {
        let value = row[col.field] || row.metadata?.[col.field] || "—";
        if (typeof value === "string" && value.length > 32000) {
          newRow[col.field] = value.substring(0, 32000) + "...";
        } else {
          newRow[col.field] = value;
        }
      });
      worksheet.addRow(newRow);
    });

    // Export to Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    saveAs(blob, "frames_search.xlsx");
  };

  return (
    <LoadingButton
      sx={{
        backgroundColor: "#16AA9D",
        color: "#fff",
        marginBottom: "10px",
        "&:hover": { backgroundColor: "#12877a" },
      }}
      loading={loading || internalLoading}
      variant="contained"
      onClick={exportToExcel}
      loadingPosition="start"
    >
      {text}
    </LoadingButton>
  );
};

export default PrintBtn;
